<template>
  <div id="lm-vue-cropper" >
    <LmComponentLoading v-show="processing" />
    <div v-show="showEditContainer" id="lm-cropper-wrapper">
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :aspect-ratio="aspectRatio"
        :minCropBoxWidth="minCropBoxWidth"
        :minCropBoxHeight="minCropBoxHeight"
        :zoomOnWheel="zoomOnWheel"
        :viewMode="viewMode"
        preview=".preview"
        @cropmove="getData"
      />
      <LmButton
        v-if="!hideCropButton"
        id="btn-crop"
        type="button"
        lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
        buttonClass="btn-primary"
        :value="$t('Crop')"
        @click.native="crop"
      />
      <LmButton
        v-if="!imgToCropWidthAsContainer"
        id="btn-zoom-in"
        type="button"
        lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
        buttonClass="btn-primary"
        :value="$t('Zoom In')"
        @click.native="zoom(0.2)"
      />
      <LmButton
        v-if="!imgToCropWidthAsContainer"
        id="btn-zoom-out"
        type="button"
        lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
        buttonClass="btn-primary"
        :value="$t('Zoom Out')"
        @click.native="zoom(-0.2)"
      />
      <LmButton
        v-if="resetFeature"
        id="btn-reset"
        type="button"
        lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
        buttonClass="btn-primary"
        :value="$t('Reset')"
        @click.native="reset"
      />
      <LmButton
        v-if="uploadAnotherImage"
        id="btn-re-upload"
        type="button"
        lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
        buttonClass="btn-primary"
        :value="$t('Subir otra imagen')"
        @click.native="reUpload"
      />
      <LmButton
        v-if="!hideSaveButton"
        :disabled="!cropImg"
        id="btn-submit"
        type="button"
        buttonClass="btn-primary"
        :value="$t('Save')"
        @click.native="submit"
      />
    </div>
    <div class="row" v-if="!showEditContainer && !showChangeCropImg">
      <div class="col-12">
        <label v-if="labelFile" for="cropper-input-image" class="d-block"> {{labelFile}} </label>
        <b-form-file
          id="cropper-input-image"
          @change="changeFile"
          placeholder="Arrastre la imagen acá para subirla"
          drop-placeholder="Arrastre la imagen acá para subirla"
          accept="image/*"
          browse-text="Seleccionar"
        />
      </div>
    </div>
    <div v-show="cropImg && !hideCropImg">
      <p>{{ labelFile }}</p>
      <img
        class="crop-img"
        :src="cropImg"
        alt="Cropped Image"
      />
      <LmButton
        id="btn-re-change-crop-img"
        v-if="showChangeCropImg"
        type="button"
        lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
        buttonClass="btn-primary"
        :value="$t('Cambiar imagen')"
        @click.native="changeCropImg"
      />
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import LmButton from '@/components/form/elements/LmButton'

import axios from 'axios'
import store from '@/store'

import { readAndCompressImage } from 'browser-image-resizer'

import 'cropperjs/dist/cropper.css'
export default {
  components: {
    VueCropper,
    LmButton
  },
  data () {
    return {
      cropImg: '',
      imgName: '',
      imgType: '',
      mustShowEditContainer: false,
      imgCropedData: {},
      processing: false,
      showChangeCropImg: false
    }
  },
  computed: {
    showEditContainer () {
      return this.imgSrc || this.mustShowEditContainer
    }
  },
  props: {
    viewMode: {
      type: Number,
      default: 0
    },
    hideSaveButton: {
      type: Boolean,
      default: false
    },
    hideCropButton: {
      type: Boolean,
      default: false
    },
    resetFeature: {
      type: Boolean,
      default: false
    },
    uploadAnotherImage: {
      type: Boolean,
      default: false
    },
    hideCropImg: {
      type: Boolean,
      default: false
    },
    imgToCropWidthAsContainer: {
      type: Boolean,
      default: false
    },
    labelFile: {
      type: String,
      default: 'Subir imágen'
    },
    imgSrc: {
      type: String,
      default: ''
    },
    aspectRatio: {
      type: Number,
      default: null
    },
    minCropBoxWidth: {
      type: Number,
      default: 0
    },
    minCropBoxHeight: {
      type: Number,
      default: 0
    },
    zoomOnWheel: {
      type: Boolean,
      default: false
    },
    initialImageSrc: {
      type: String,
      default: ''
    }
  },
  watch: {
    initialImageSrc () {
      this.cropImg = this.initialImageSrc
    }
  },
  mounted () {
    this.cropImg = this.initialImageSrc
  },
  methods: {
    reUpload () {
      this.mustShowEditContainer = false
      this.cropImg = ''
    },
    changeCropImg () {
      this.mustShowEditContainer = false
      this.cropImg = ''
      this.showChangeCropImg = false
    },
    crop () {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
    },
    zoom (percent) {
      this.$refs.cropper.relativeZoom(percent)
      this.getData()
    },
    reset () {
      this.$refs.cropper.reset()
      this.cropImg = ''
      this.$emit('reset')
    },
    replace (url) {
      this.$refs.cropper.replace(url)
      this.$emit('imageLoadedToBeCrop')
    },
    getData (rounded = true) {
      this.imgCropedData = this.$refs.cropper.getData(rounded)
    },
    getImageData () {
      return this.$refs.cropper.getImageData()
    },
    getCropImg () {
      this.$emit('getCropImg', this.cropImg)
    },
    getContainerData () {
      return this.$refs.cropper.getContainerData()
    },
    async imgToCropWidthAsContainerMethod (file) {
      const originalImage = {
        width: null,
        height: null,
        aspectRatio: null
      }
      const container = {
        width: null,
        height: null
      }
      originalImage.width = this.getImageData().naturalWidth
      originalImage.height = this.getImageData().naturalHeight
      originalImage.aspectRatio = this.getImageData().aspectRatio

      container.width = this.getContainerData().width
      container.height = this.getContainerData().height

      const config = {
        quality: 1,
        maxWidth: container.width,
        maxHeight: originalImage.height,
        mimeType: file.type
      }
      let resizedImage = await readAndCompressImage(file, config)
      return resizedImage
    },
    changeFile (e) {
      const file = e.target.files[0]
      this.imgName = file.name
      this.imgType = file.type
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        this.processing = true
        this.$refs.cropper.replace(URL.createObjectURL(file))
        this.$emit('imageLoadedToBeCrop')
        this.cropImg = ''
        this.mustShowEditContainer = true
        if (this.imgToCropWidthAsContainer) {
          setTimeout(async () => {
            const fileResized = await this.imgToCropWidthAsContainerMethod(file)
            this.$refs.cropper.replace(URL.createObjectURL(fileResized))
            this.processing = false
          }, 500)
        } else {
          this.processing = false
        }
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    async submit () {
      let imageSrc = this.cropImg
      const res = await fetch(imageSrc)
      const blob = await res.blob()
      const file = new File([blob], this.imgName ? this.imgName + '.png' : 'img-name.png', { type: 'image/png' })

      let fd = new FormData()
      fd.append('profilePicture', file)
      try {
        this.processing = true

        const response = await axios.post(`/upload`, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${store.state.session.accessToken}`
          }
        })

        this.$emit('imageCropperChanged', process.env.VUE_APP_API_URL_STATIC_ASSETS + response.data.path)
        this.$emit('input', response.data)
        this.mustShowEditContainer = false
        imageSrc = ''
        this.showChangeCropImg = true
      } catch (error) {
        console.log('error', error)
      } finally {
        this.processing = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.crop-img
  max-width: 300px
  display: block
</style>
